export default __webpack_public_path__ + "static/images/Dahyun_1_thumb.png";